import _ from 'lodash';
var EventEmitter = require('event-emitter');

export default class HotGlue {

  emitter = new EventEmitter();
  init = false;
  name = "AppState";
  useLocalStorage = false;
  _listeners = [];
  state = {};
  actions = {};
  derived = {};

  constructor(settings) {

    // only init if it hasn't been inited.
    if (!this.init) {

      if (settings.initial) this.state = settings.initial;
      if (settings.name) this.name = settings.name;
      if (settings.actions) this.actions = settings.actions;
      if (settings.derived) this.derived = settings.derived;
      if (settings.useLocalStorage) this.useLocalStorage = settings.useLocalStorage;

      this.init = true;

      this._setupLocalStorage();
      this._bindActions();

    }

  }

  _setupLocalStorage() {
    if (typeof localStorage !== "undefined" && this.useLocalStorage) {

      var currentStore = localStorage.getItem(this.name);

      if (!currentStore) {
        localStorage.setItem(this.name, JSON.stringify(this.state));
      } else {
        this.state = JSON.parse(currentStore);
      }

    }
  }

  _createAction(_actionName) {

    // use a closure to store the function names.
    var actionName = _actionName;

    return function() {

      this.actions[actionName].call(this, this.state, ...arguments);
      this.emitter.emit("change");

      if (this.useLocalStorage) {
        localStorage.setItem(this.name, JSON.stringify(this.state));
      }

    }.bind(this);

  }

  _bindActions() {
    for (var i in this.actions) {
      this[i] = this._createAction(i)
    }
  }

  listen(whitelist = [], cb =  _.noop) {

    if (_.isFunction(whitelist)) {
      cb = whitelist;
    }


    var listener = cb.bind(null, this.state);

    this._listeners.push({original: cb, listener});
    this.emitter.on('change', listener);

  }

  stopListening(cb) {
    this._listeners.forEach((listener) => {
      if (listener.original === cb) {
        this.emitter.off('change', listener.original);
        this.emitter.off('change', listener.listener);
      }
    })
  }

  connect(React, WrappedComponent) {

    var _this = this;

    return class extends React.Component {

      constructor(props) {

        super(props);

        this.state = {};
        this.state[_this.name] = _this.state;

        _this.listen(this.onStateChange = (newState) => {
          this.state[_this.name] = newState;
          this.setState(this.state);
          window.HOTSTATE = this.state;
        });

      }

      componentWillUnmount() {
        _this.stopListening(this.onStateChange);
      }

      render() {
        return (
          <WrappedComponent {...this.state} {...this.props} />
        )
      }

    }
  }

}



// WEBPACK FOOTER //
// ./src/state/hotglue.js